import { createContext, ElementType } from "react";

export const MenuContext = createContext<{ linkComponent: ElementType; drawerOpen: boolean }>({
  linkComponent: "a",
  drawerOpen: true,
});
